import SelectedCountAmenity
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/components/SelectedCountAmenity";
import useCreateSelectedAmenitiesSummary
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/hooks/useCreateSelectedAmenitiesSummary";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import roundToTwoDecimals from "@Number/roundToTwoDecimals";

interface SelectedCountAmenityListProps {
    pairedAmenityGroups: PairedSingleAndReturnAmenitiesType,
    openAmenities: () => void
}

function SelectedCountAmenityList({openAmenities, pairedAmenityGroups}: SelectedCountAmenityListProps) {
    const {
        createSummaryPerAmenityKey,
        getValidAmenityKeys,
    } = useCreateSelectedAmenitiesSummary(pairedAmenityGroups)

    return (
        <button
            type="button"
            onClick={openAmenities}
            className="ticket-amenities__selected-list"
        >
            {getValidAmenityKeys().map((amenityKey) => {
                const {
                    totalPricePerAmenity,
                    icon,
                    description,
                } = createSummaryPerAmenityKey(amenityKey)

                return (
                    <SelectedCountAmenity
                        totalPricePerAmenity={roundToTwoDecimals(totalPricePerAmenity)}
                        icon={icon}
                        description={description}
                        key={amenityKey}
                    />
                )
            })}
        </button>
    )
}

export default SelectedCountAmenityList